import { UpdateTag } from 'components/tag/UpdateTag'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'
import { ReactComponent as WriteIcon } from 'svg/fi_write.svg'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormValues } from 'utils/type'
import { LinkDetailType, PromptGroup, ToneType } from 'service/list'
import { Me } from 'service/user'
import classNames from 'classnames'
import { ScriptTooltip } from '../tooltip/ScriptTooltip'
import { ScriptLoadingSkeleton } from '../skeleton/ScriptLoadingSkeleton'
import useGenerateScriptPolling from 'hooks/useGenerateScriptPolling'
import { ScriptSelector } from './ScriptSelector'
import { useScriptStore } from 'store/useScriptStore'
import useGenerateScript from 'hooks/query/extension/useGenerateScript'
import { isMobile } from 'react-device-detect'
import { splitTextIntoScenes } from 'pages/content-video-editor/utils'
interface ProductScriptProps {
  index: number
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  translatePlanName: (planName: string) => string
  promptGroupList: PromptGroup[] | undefined
  userInfo: Me
  setPromptStatus: Dispatch<SetStateAction<boolean[]>>
  setToneTooltip: Dispatch<SetStateAction<boolean[]>>
  promptStatus: boolean[]
  toneTooltip: boolean[]
  selectedLink: LinkDetailType | null
}

export const ProductScript = ({
  index,
  watch,
  setValue,
  control,
  translatePlanName,
  promptGroupList,
  userInfo,
  setPromptStatus,
  setToneTooltip,
  promptStatus,
  toneTooltip,
  selectedLink,
}: PropsWithChildren<ProductScriptProps>) => {
  const PRODUCT_NAME_PATTERN = /^[^<>\uD800-\uDFFF]*$/

  const [scriptStatus, setScriptStatus] = useState<string | null>(null)

  const { promptName, toneName, toggleModal, isAIGenerated } = useScriptStore()
  const { mutateAsync: generateScriptMutate } = useGenerateScript(
    selectedLink?.id ?? 0,
  )
  const [isCyclingMessage, setIsCyclingMessage] = useState(false)
  const [messageIndex, setMessageIndex] = useState<number>(0)

  const [isSuccessGenerateScript, setSuccessGenerateScript] =
    useState<boolean>(false)
  const { data, isPolling, startPolling, setIsPolling } =
    useGenerateScriptPolling(
      selectedLink?.id ?? null,
      index,
      setValue,
      setSuccessGenerateScript,
      setIsCyclingMessage,
      setScriptStatus,
    )

  const [loadingMessages, setLoadingMessages] = useState<string[]>([
    '상품 분석중...',
    '내용 구성중... ',
    '컨셉 적용중...',
    '말투 적용중...',
  ])

  const generateScript = async () => {
    console.log('📤 generateScript 호출됨')
    setValue(`products.${index}.userScript`, '')
    setIsPolling(true)

    if (selectedLink?.id) {
      console.log('📌 스크립트 요청 시작', selectedLink.id)
      // 상태값 201
      // 상태값 error 두개의 값만 존재 error경우에는 아직 생성중인 스크립트가 있음
      // 201여도 error여도 폴링은 해야하는것
      // 워커에 스크립트 생성 요청 api
      try {
        await generateScriptMutate({
          extensionCollectId: selectedLink.id,
          aiToneTypeId: watch('aiToneTypeId'),
          aiPromptTypeId: watch('aiPromptTypeId'),
        })
      } catch (e) {
        console.error('❌ 스크립트 요청 실패', e)
      }
    }
    console.log('🔁 startPolling 호출')
    startPolling()
    setIsCyclingMessage(true)
  }

  useEffect(() => {
    if (!isCyclingMessage) return

    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % loadingMessages.length)
    }, 5000)

    const timeout = setTimeout(() => {
      setIsCyclingMessage(false) // 30초 후 자동 종료
    }, 40000)

    return () => {
      setMessageIndex(0)
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [isCyclingMessage])

  useEffect(() => {
    setSuccessGenerateScript(false)
    if (
      selectedLink &&
      selectedLink?.generateScriptRequest?.status === 'done' &&
      !isAIGenerated
    ) {
      const { aiScript } = selectedLink?.generateScriptRequest
      setValue(`products.${index}.userScript`, aiScript)
      setScriptStatus('done')
    } else if (selectedLink) {
      setValue(`products.${index}.userScript`, '')
    }
  }, [selectedLink])

  return (
    <>
      <div className="mt-6 flex w-full flex-col" key={`product_${index}`}>
        <div className="relative flex w-full justify-between">
          <p className="flex items-center gap-2">
            <WriteIcon />
            <span className="font-bold">AI 대본 생성 & 편집</span>
            <UpdateTag />
          </p>

          <div className="flex items-center gap-2">
            {/* <label className="flex items-center gap-2 cursor-pointer">
              <div className="relative h-5 w-5 shrink-0">
                <input
                  type="checkbox"
                  checked={isCheck}
                  onChange={(e) => {
                    const value: boolean = e.target.checked
                    // setValue('userWritten', value ? 1 : 0)
                    setCheck(value)
                  }}
                  className="sr-only peer"
                />

                <span className="absolute inset-0 flex items-center justify-center rounded-[4px] bg-[#e4e7ec] peer-checked:bg-href peer-checked:before:text-xl before:text-white before:content-['✓']"></span>
              </div>

              <span className="">AI에게 맡기기</span>
            </label> */}
            {/* <div className=" relative">
              <img
                src="assets/img/icon_tooltip.png"
                alt="툴팁"
                className=" w-[20px] h-[20px] cursor-pointer"
                onClick={() => {
                  setOpenTooltip(true)
                }}
              />
              {isOpenTooltip && (
                <ScriptTooltip setOpenTooltip={setOpenTooltip} />
              )}
            </div> */}
          </div>
        </div>
        <div className="mt-2 flex flex-col rounded-[10px] border-[1px]">
          <div className="w-full rounded-t-[10px] bg-[#F6F8FB] px-3 py-2">
            <div className="flex flex-col justify-between gap-2 md:flex-row md:items-center">
              <div className="flex w-full items-center justify-between rounded-[10px] bg-white px-4 py-5 font-bold md:h-[61px]">
                <div className="flex w-full flex-col gap-4 md:flex-row md:items-center md:gap-5">
                  <p className="flex flex-shrink-0 items-center gap-2 text-[14px]">
                    <span className="flex-shrink-0 rounded-[4px] bg-[#D9DEE8] px-1 py-[2px] text-[#8F929B]">
                      컨셉
                    </span>
                    <span
                      className={classNames('', {
                        'text-black': !isPolling,
                        'text-[#8F929B]': isPolling,
                      })}
                    >
                      {promptName ?? '바이럴형'}
                    </span>
                  </p>
                  <p className="flex items-center gap-2 text-[14px]">
                    <span className="flex-shrink-0 rounded-[4px] bg-[#D9DEE8] px-1 py-[2px] text-[#8F929B]">
                      말투
                    </span>
                    <span
                      className={classNames('', {
                        'text-black': !isPolling,
                        'text-[#8F929B]': isPolling,
                      })}
                    >
                      {toneName ?? '와 이런게 있다고?'}
                    </span>
                  </p>{' '}
                </div>
                <button
                  className={classNames(
                    'shrink-0 rounded-[4px] bg-black px-2 py-[6px] text-[14px] text-[white] disabled:bg-[#D9DEE8]',
                    {
                      'bg-gradient-to-r(#6095FF,#00CBB3)': isPolling,
                    },
                  )}
                  onClick={toggleModal}
                  type="button"
                  disabled={isPolling}
                >
                  선택 {'>'}
                </button>
              </div>
              <div
                className="flex shrink-0 justify-center"
                onClick={generateScript}
              >
                <button
                  type="button"
                  className={classNames(
                    'shrink-1 flex items-center gap-2 rounded-full px-6 py-3 disabled:bg-[#D9DEE8]',
                    {
                      'bg-gradient-to-r from-[#6095FF] to-[#00CBB3]':
                        !isPolling && !isAIGenerated,
                    },
                  )}
                  disabled={isPolling || isAIGenerated}
                >
                  <StarIcon />
                  <span className="font-bold text-white">AI 대본 생성하기</span>
                </button>
              </div>
            </div>
          </div>

          <div className="relative flex flex-col gap-2 rounded-b-[10px] bg-white">
            <Controller
              name={`products.${index}.userScript`}
              rules={{
                maxLength: {
                  value: 500,
                  message: '스크립트 길이가 500자를 넘습니다.',
                },
                validate: (value) => {
                  if (value === '' && !isAIGenerated) {
                    return '값을 입력해주세요'
                  }
                  if (!PRODUCT_NAME_PATTERN.test(value) && !isAIGenerated) {
                    return '이모지, 한자(漢字), 꺽쇠괄호(< >) 는 허용되지 않습니다.'
                  }
                  if (
                    splitTextIntoScenes(value, 0).length < 3 &&
                    !isAIGenerated
                  ) {
                    return '각 문장마다 마침표를 정확히 사용해주세요!'
                  }
                },
              }}
              control={control}
              defaultValue=""
              render={({ field, fieldState }) => {
                const value = field.value ?? ''
                const scenes = splitTextIntoScenes(value, 4)
                const scenesLength = scenes.length
                const isInvalid =
                  value.length > 500 || !PRODUCT_NAME_PATTERN.test(value)

                const isMinSentence = scenesLength >= 3

                return (
                  <>
                    <textarea
                      {...field}
                      className={classNames(
                        'w-full rounded-b-[10px] bg-white px-3 py-3 focus:outline-none disabled:bg-gray-100',
                        {
                          'border border-error focus:outline-none':
                            (!isMinSentence || isInvalid) &&
                            scriptStatus === 'done' &&
                            !isAIGenerated,
                          'border-none': isMinSentence && !isInvalid,
                          'min-h-[260px]': !isMobile,
                          'min-h-[400px]': isMobile,
                        },
                      )}
                      maxLength={500}
                      disabled={scriptStatus !== 'done' || isAIGenerated}
                    />
                    {isPolling && (
                      <ScriptLoadingSkeleton
                        messageIndex={messageIndex}
                        loadingMessages={loadingMessages}
                      />
                    )}
                    <div className="absolute bottom-8 flex w-full items-center justify-between px-3">
                      <span
                        className={classNames('', {
                          'text-[#8F929B]': !isInvalid,
                          'text-error': isInvalid,
                        })}
                      >{`이모지, 한자(漢字), 꺽쇠괄호(< >) 는 허용되지 않습니다.`}</span>
                      <span
                        className={classNames('', {
                          'text-[#8F929B]': !isInvalid,
                          'text-error': isInvalid,
                        })}
                      >{`(${value.length}/500)`}</span>
                    </div>
                    <div className="absolute bottom-2 flex w-full items-center justify-between px-3">
                      <span
                        className={classNames('text-[#8F929B]', {
                          'text-[#8F929B]': isMinSentence,
                          'text-error':
                            !isMinSentence &&
                            scriptStatus === 'done' &&
                            !isAIGenerated,
                        })}
                      >{`각 문장마다 마침표를 정확히 사용해주세요!`}</span>
                    </div>
                  </>
                )
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}
